import { useState } from 'react';

interface WhatsAppReminderBannerProps {
  whatsappConnected: boolean;
}

export function WhatsAppReminderBanner({ whatsappConnected }: WhatsAppReminderBannerProps) {
  const [dismissed, setDismissed] = useState(false);

  if (whatsappConnected || dismissed) {
    return null;
  }

  return (
    <div className="mx-4 mt-2 rounded-xl border border-accent/30 bg-accent-bg px-3 py-2">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-2">
          <span className="material-icons-round text-accent text-lg mt-0.5">phone_iphone</span>
          <div>
            <p className="text-sm font-medium text-ink" data-ph-no-mask>
              Connect WhatsApp to get started
            </p>
            <p className="text-xs text-ink-secondary mt-0.5" data-ph-no-mask>
              Clawer needs WhatsApp to analyze your conversations and help you stay connected.
            </p>
          </div>
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="text-ink-tertiary hover:text-ink-secondary transition-colors flex-shrink-0"
          aria-label="Dismiss"
        >
          <span className="material-icons-round text-sm">close</span>
        </button>
      </div>
    </div>
  );
}
